import { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { fetchBootstrap } from '../api/store.js';
import { FALLBACK_CURRENCY_CONFIG } from '../lib/currency.js';

const StoreConfigContext = createContext(null);

const EMPTY_CONFIG = {
  site: { name: 'SkyExpress', server_ip: '', discord_url: '#', website_url: '#' },
  currency: FALLBACK_CURRENCY_CONFIG,
  categories: [],
  rankState: 'logged_out',
  announcement: null,
  goal: null,
  topCustomer: null,
};

export function StoreConfigProvider({ children }) {
  const [config, setConfig] = useState(EMPTY_CONFIG);
  const [isLoading, setIsLoading] = useState(true);

  const load = useCallback(async () => {
    const data = await fetchBootstrap();

    setConfig({
      site: data.site ?? EMPTY_CONFIG.site,
      currency: data.currency ?? EMPTY_CONFIG.currency,
      categories: data.categories ?? [],
      rankState: data.rank_state ?? 'logged_out',
      announcement: data.announcement ?? null,
      goal: data.goal ?? null,
      topCustomer: data.top_customer ?? null,
    });
    setIsLoading(false);
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const value = useMemo(() => ({ ...config, isLoading, reload: load }), [config, isLoading, load]);

  return <StoreConfigContext.Provider value={value}>{children}</StoreConfigContext.Provider>;
}

export function useStoreConfig() {
  const context = useContext(StoreConfigContext);

  if (!context) {
    throw new Error('useStoreConfig must be used inside a StoreConfigProvider');
  }

  return context;
}
